import { capture } from '../analytics';
import Icon from './Icon';
import React, { useState } from 'react';

export default function NewsletterSignup({ id = 'newsletter' }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [fallback, setFallback] = useState(false);
  async function subscribe(event) {
    event.preventDefault();
    if (status === 'loading') return;
    setStatus('loading'); setFallback(false); setMessage('');
    const check = new FormData(event.currentTarget).get('_newsletter_check');
    try {
      const response = await fetch('/api/newsletter', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, _newsletter_check: check }) });
      let data;
      try { data = await response.json(); } catch { throw new Error('network'); }
      if (!response.ok) {
        setStatus('error'); setFallback(true);
        setMessage(typeof data.message === 'string' ? data.message : 'We couldn’t complete signup. Please try again.');
        return;
      }
      capture('f1000_newsletter_submitted', { placement: id, path: window.location.pathname });
      setStatus('success'); setMessage(data.message || 'Check your inbox to confirm your subscription.');
    } catch { setStatus('error'); setFallback(true); setMessage('We couldn’t complete signup. Please try again or use our newsletter page.'); }
  }
  return <div className="f1000-signup">
    {status === 'success' ? <div className="f1000-signup-success" role="status"><Icon size={18}/><div><strong>Check your inbox.</strong><p>{message}</p></div></div> :
      <form action="/api/newsletter" method="post" onSubmit={subscribe} className="signup-form">
        <label className="f1000-sr-only" htmlFor={id}>Email address</label>
        <input id={id} name="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required maxLength={254} autoComplete="email" placeholder="Your email address" aria-describedby={`${id}-message`} />
        <div className="f1000-honeypot" aria-hidden="true"><label htmlFor={`${id}-check`}>Leave this blank</label><input id={`${id}-check`} name="_newsletter_check" tabIndex={-1} autoComplete="off" data-1p-ignore data-lpignore="true" /></div>
        <button type="submit" disabled={status === 'loading'}>{status === 'loading' ? 'Subscribing…' : 'Subscribe free'} <Icon size={18}/></button>
      </form>}
    <p id={`${id}-message`} className="f1000-form-note" role={status === 'error' ? 'alert' : undefined}>{message && status !== 'success' ? message : 'Free to read. One click to unsubscribe.'} {fallback && <a href="https://newsletter.first1000.co/subscribe">Subscribe on our newsletter page <Icon size={14}/></a>}</p>
  </div>;
}
